// extracted by mini-css-extract-plugin
export var colorSquare = "_u3-0";
export var danger = "_u3-5";
export var lightPink = "_u3-8";
export var neutralBlue = "_u3-7";
export var neutralYellow = "_u3-6";
export var normal = "_u3-1";
export var primary = "_u3-2";
export var primaryLight = "_u3-3";
export var solidBlack = "_u3-g";
export var solidGreen = "_u3-b";
export var solidLightBlue = "_u3-d";
export var solidNavy = "_u3-c";
export var solidOrange = "_u3-f";
export var solidPink = "_u3-e";
export var solidRed = "_u3-9";
export var solidYellow = "_u3-a";
export var success = "_u3-4";